import { IconList } from "@/components/IconList";
import { Typography } from "@/components/Typography";
import { Icons } from "@/types/icons";
import { formatToBusinessHoursPreview } from "@/utils/timerHelper";
import type { DayKey } from "@/components/BusinessHours/types";
import type { BusinessOpeningHoursProps } from "../types";
import { getEnabledBusinessDays, OPENING_HOURS_DAY_TRANSLATION_KEYS } from "../utils";

const renderDayRow = (
  day: DayKey,
  translation: string | undefined,
  businessHours: BusinessOpeningHoursProps["businessHours"]
) => {
  const daySchedule = businessHours.days[day];

  return (
    <div
      key={day}
      className="business-template__opening-hours-row"
    >
      <Typography
        Tag="p"
        size="xs"
        classname="u-spacing-0 u-grey-800"
      >
        {translation}
      </Typography>
      <div className="business-template__opening-hours-list">
        {daySchedule.times.map((time, index) => (
          <Typography
            key={`${day}-${index}`}
            Tag="p"
            size="xs"
            classname="u-spacing-0 u-grey"
          >
            {formatToBusinessHoursPreview(time.start, businessHours.format)}
            {" - "}
            {formatToBusinessHoursPreview(time.end, businessHours.format)}
          </Typography>
        ))}
      </div>
    </div>
  );
};

export const BusinessOpeningHours = ({
  businessHours,
  translations,
}: BusinessOpeningHoursProps) => {
  const enabledDays = getEnabledBusinessDays(businessHours);

  return (
    <div className="u-card">
      <IconList
        iconItem
        items={{
          icon: Icons.clock,
          title: translations?.preview_opening_hours,
        }}
        tag="h6"
        semibold
      />
      {enabledDays.map((day) =>
        renderDayRow(day, translations?.[OPENING_HOURS_DAY_TRANSLATION_KEYS[day]], businessHours)
      )}
    </div>
  );
};
